export enum WagoApiStatusCode {
  Ok = 200,
  BadRequest = 400,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  RequestTimeout = 408,
  InternalServerError = 500,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  NetworkReadTimeoutError = 598,
  CloudflareWebServerDown = 521,
  CloudflareConnectionTimedOut = 522,
  CloudflareOriginIsUnreachable = 523,
  CloudflareTimeout = 524,
}
